import { render, staticRenderFns } from "./common_instant.vue?vue&type=template&id=db3630da&"
import script from "./common_instant.vue?vue&type=script&lang=js&"
export * from "./common_instant.vue?vue&type=script&lang=js&"
import style0 from "./common_instant.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports